<template>
  <div>
    <ul class="nav nav-actions" v-if="canPerformUserActions && user.isCarrier && user.isNotActivated">
      <li>
        <a @click="handleCarrierActiviation">
          <i class="fa fa-circle-o-notch fa-spin fa-fw" v-if="performingCarrierActivation"></i>
          <i class="fa fa-check" v-else></i>
          Activate Carrier Account
        </a>
      </li>
    </ul>
    <ul class="nav nav-actions" v-if="canPerformUserActions && user.isNotArchived && user.isActivated">
      <li v-if="user.isUnverified">
        <a @click="handleVerificationMail">
          <i class="fa fa-circle-o-notch fa-spin fa-fw" v-if="performingUserVerificationMail"></i>
          <i class="fa fa-send fa-fw" v-else></i>
          Verification Email
        </a>
      </li>
      <li v-if="user.isUnverified">
        <a @click="handleManualVerification">
          <i class="fa fa-circle-o-notch fa-spin fa-fw" v-if="performingUserManualVerification"></i>
          <i class="fa fa-check fa-fw" v-else></i>
          Manual Verification
        </a>
      </li>
      <li v-if="user.isEnabled">
        <a @click="handleDisable">
          <i class="fa fa-circle-o-notch fa-spin fa-fw" v-if="performingUserDisabling"></i>
          <i class="fa fa-times fa-fw" v-else></i>
          Disable User
        </a>
      </li>
      <li v-if="user.isDisabled">
        <a @click="handleEnable">
          <i class="fa fa-circle-o-notch fa-spin fa-fw" v-if="performingUserEnabling"></i>
          <i class="fa fa-refresh fa-fw" v-else></i>
          Enable User
        </a>
      </li>
      <li v-if="user.isNotArchived">
        <a @click="handleArchive">
          <i class="fa fa-circle-o-notch fa-spin fa-fw" v-if="performingUserArchive"></i>
          <i class="fa fa-archive fa-fw" v-else></i>
          Archive User
        </a>
      </li>
    </ul>

    <div class="row m-b-lg" v-if="user.isClientOrCarrier">
      <div class="col-xs-12 col-sm-8 col-md-9">
        <account-credit></account-credit>
      </div>
      <div class="col-xs-12 col-sm-4 col-md-3 text-right" v-if="editingOwnDetails || $user.isAdmin">
        <router-link :to="routeToCreditNotes" class="btn btn-primary btn-block btn-sm m-t-sm"><i class="fa fa-money"></i> Credit Notes</router-link>
      </div>
    </div>

    <div class="ibox">
      <div class="ibox-content">

        <form class="form-material" data-vv-scope="account">
          <h2>Account Details</h2>

          <div class="margin-20"></div>

          <div class="row row-clear-md-6">
            <div class="col-md-6">
              <div class="form-group-outer">
                <div class="form-group float-label-control" :class="{ 'has-error': errors.has('account.name') }">
                  <label for="">First Name</label>

                  <input
                    type="text"
                    class="form-control"
                    placeholder="First Name"
                    v-model="name"
                    name="name"
                    v-validate="'required'"
                    v-float-label>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group-outer">
                <div class="form-group float-label-control" :class="{ 'has-error': errors.has('account.surname') }">
                  <label for="">Surname</label>

                  <input
                    type="text"
                    class="form-control"
                    placeholder="Surname"
                    name="surname"
                    v-validate="'required'"
                    v-model="surname"
                    v-float-label>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group-outer">
                <div class="form-group float-label-control" :class="{ 'has-error': errors.has('account.mobile') }">
                  <label for="">Mobile Number</label>

                  <input
                    type="text"
                    class="form-control"
                    placeholder="Mobile Number"
                    name="mobile"
                    v-validate="'required'"
                    v-model="mobile"
                    v-float-label>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group-outer">
                <div class="form-group float-label-control" :class="{ 'has-error': errors.has('account.email') }">
                  <label for="">Email Address</label>

                  <input
                    type="text"
                    class="form-control"
                    placeholder="Email Address"
                    name="email"
                    v-validate="'required'"
                    v-model="email"
                    v-float-label>
                </div>
              </div>
            </div>
          </div>

          <template v-show="userIsMasterClientOrCarrier">
            <h2>Company Details</h2>

            <div class="margin-20"></div>

            <div class="form-group-outer">
              <div class="form-group float-label-control" :class="{ 'has-error': errors.has('account.company_name') }">
                <label for="">Entity Name</label>

                <input
                  type="text"
                  class="form-control"
                  placeholder="Entity Name"
                  name="company_name"
                  v-validate="'required'"
                  v-model="companyName"
                  v-float-label>
              </div>
            </div>

            <div class="row row-clear-md-6">
              <div class="col-md-6">
                <div class="form-group-outer">
                  <div class="form-group float-label-control" :class="{ 'has-error': errors.has('account.company_phone') }">
                    <label for="">Phone Number</label>

                    <input
                      type="text"
                      class="form-control"
                      placeholder="Phone Number"
                      name="company_phone"
                      v-validate="'required'"
                      v-model="companyPhone"
                      v-float-label>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group-outer">
                  <div class="form-group float-label-control" :class="{ 'has-error': errors.has('account.company_abn') }">
                    <label for="">ABN</label>

                    <input
                      type="text"
                      class="form-control"
                      placeholder="ABN"
                      name="company_abn"
                      v-validate="'required'"
                      v-model="companyAbn"
                      v-float-label>
                  </div>
                </div>
              </div>
            </div>

            <h2>Billing Address</h2>

            <div class="margin-20"></div>

            <div class="form-group-outer">
              <div class="form-group float-label-control" :class="{ 'has-error': errors.has('account.address_line_one') }">
                <label for="">Line 1</label>

                <input
                  type="text"
                  class="form-control"
                  placeholder="Line 1"
                  name="address_line_one"
                  v-validate="'required'"
                  v-model="addressLineOne"
                  v-float-label>
              </div>
            </div>

            <div class="form-group-outer">
              <div class="form-group float-label-control">
                <label for="">Line 2</label>

                <input
                  type="text"
                  class="form-control"
                  placeholder="Line 2"
                  name="address_line_two"
                  v-model="addressLineTwo"
                  v-float-label>
              </div>
            </div>

            <div class="form-group-outer">
              <div class="form-group float-label-control" :class="{ 'has-error': errors.has('account.suburb') }">
                <label for="">Suburb</label>

                <input
                  type="text"
                  class="form-control"
                  placeholder="Suburb"
                  name="suburb"
                  v-validate="'required'"
                  v-model="suburb"
                  v-float-label>
              </div>
            </div>

            <div class="row row-clear-md-6">
              <div class="col-md-6">
                <div class="form-group-outer">
                  <div class="form-group float-label-control" :class="{ 'has-error': errors.has('account.state') }">
                    <label for="" class="select-label">State</label>

                    <selectize
                      v-model="state"
                      v-validate:state="'required'"
                      data-vv-name="state"
                      name="state"
                      :options="stateOptions">
                    </selectize>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group-outer">
                  <div class="form-group float-label-control" :class="{ 'has-error': errors.has('account.postcode') }">
                    <label for="">Postcode</label>

                    <input
                      type="text"
                      class="form-control"
                      placeholder="Postcode"
                      name="postcode"
                      v-validate="'required'"
                      v-model="postcode"
                      v-float-label
                    />
                  </div>
                </div>
              </div>
            </div>
          </template>

          <div class="text-right">
            <ladda-button type="success" :on-click="handleSaveAccountDetails">Save Changes</ladda-button>
          </div>
        </form>
      </div>
    </div>

    <div class="ibox" v-show="userIsCarrier">
      <div class="ibox-content">

        <form class="form-material">

          <div class="row">
            <div class="col-sm-6">
              <h2>My Driving Details</h2>
            </div>
            <div class="col-sm-6">
              <div class="checkbox checkbox-primary pull-right">
                <input v-model="is_driver" id="check-terms" class="styled" type="checkbox" />
                <label for="check-terms">
                  I am also a truck driver
                </label>
              </div>
            </div>
          </div><!-- /.row -->

          <div class="margin-20"></div>

          <div class="row" v-if="is_driver">
            <div class="col-md-5 col-lg-4">

              <photo-cropper
                v-model="photo"
                name="driver"
                :photo-storage-path="photoPath"
                :original-name="photoName"
                :original-data-uri="originalPhotoDataUri"
                class-name="profile-photo"
                label-text="Profile Photo">
              </photo-cropper>

            </div>
            <div class="col-md-7 col-lg-8">

              <div class="form-group-outer">
                <div class="form-group float-label-control">
                  <label for="">Drivers Licence</label>
                  <input type="text" v-model="licence" class="form-control" placeholder="Drivers Licence" v-float-label/>
                </div>
              </div><!-- /.form-group-outer -->
              <div class="form-group-outer">
                <div class="form-group float-label-control">
                  <label for="">Licence Expiry</label>
                  <date-range v-model="licenceExpiry" name="licence_expiry" :single-date-picker="true" opens="right" v-float-label></date-range>
                </div>
              </div><!-- /.form-group-outer -->

            </div>
          </div><!-- /.row -->

          <div class="text-right">
            <ladda-button type="info" :on-click="handleSaveDriverDetails">Save Details</ladda-button>
          </div>

        </form><!-- /.form-material -->

      </div>
    </div><!-- /.ibox -->

    <div class="ibox" v-if="canUploadInsuranceDocument">
      <div class="ibox-title">
        <h2>Insurance Documents <a href="#" class="btn btn-circle btn-info pull-right" data-toggle="modal" data-target=".modal-insurance-documents"><i class="fa fa-question"></i></a></h2>
      </div>
      <div class="ibox-content">
        <ul class="list-detail list-detail-documents">
          <li v-for="document in user.documents" :key="document.id">
            <div class="row">
              <div class="col-sm-8 col-md-5 col-lg-6">
                <p class="material-details">
                  <strong>Document</strong><br />
                  {{ document.title }}
                </p>
              </div>
              <div class="col-sm-4 col-md-2 col-lg-2">
                <p class="material-details">
                  <strong>Expires</strong><br />
                  {{ document.expiry ? document.expiry : '&ndash;' }}
                </p>
              </div>
              <div class="col-sm-12 col-md-5 col-lg-4">
                <div class="btn-toolbar">
                  <a :href="getDocumentDownloadUrl(document)" class="btn btn-sm btn-primary"><i class="fa fa-download"></i> Download</a>
                  <a @click="handleEditDocument(document)" class="btn btn-sm btn-info"><i class="fa fa-pencil"></i></a>
                  <a @click="handleDeleteDocument(document)" class="btn btn-sm btn-danger"><i class="fa fa-trash"></i></a>
                </div>
              </div>
            </div><!-- /.row -->
          </li>
          <li v-if="noUserDocuments" class="text-muted text-center" style="margin-bottom: 10px">No insurance documents</li>
        </ul>
      </div>
      <div class="document-details-collapse collapse">
        <div class="ibox-footer">

          <h4 v-if="editingDocument">Edit Document</h4>
          <h4 v-else>Add Document</h4>

          <div class="row">
            <form data-vv-scope="document">
              <div class="col-sm-8 col-lg-4">
                <div class="form-group">
                  <label class="control-label">Document Title</label>
                  <input type="text" v-model="insuranceDocument.title" class="form-control" placeholder="" />
                </div>
              </div>
              <div class="col-sm-4 col-lg-2">
                <div class="form-group">
                  <label class="control-label" >Expires</label>
                  <date-range v-model="insuranceDocument.expiry" name="expiry" :single-date-picker="true" opens="right"></date-range>
                </div>
              </div>

              <div class="col-sm-12 col-lg-6">
                <div class="row">
                  <div class="col-sm-8">
                    <div class="form-group" :class="{ 'has-error': errors.has('document.file') }">
                      <label class="control-label">File</label>
                      <input type="text" class="form-control" :value="insuranceDocument.file_name ? insuranceDocument.file_name : null" placeholder=""  disabled/>
                    </div>
                  </div>
                  <div class="col-sm-4">
                    <label class="btn btn-primary btn-sm m-t-md btn-block" for="insurance_document">
                      <input type="file" class="sr-only" v-validate="'required'" id="insurance_document" name="file" @change="handleFileSelection" @input="handleFileSelection">
                      Select File
                    </label>
                  </div>
                </div><!-- /.row -->
              </div>
            </form>
          </div><!-- /.row -->

          <div class="text-right">
            <ladda-button v-if="editingDocument" type="success" size="small" :on-click="handleSaveDocument" class="m-t-md m-b-md">Save Changes</ladda-button>
            <ladda-button v-else type="success" size="small" :on-click="handleSaveDocument" class="m-t-md m-b-md">Add Document</ladda-button>
          </div>

        </div>
      </div>
      <div @click="handleAddDocument" style="cursor: pointer" class="ibox-footer ibox-footer-document-control text-center" >
        <i class="fa fa-plus"></i> Add Document
      </div>

    </div><!-- /.ibox -->

    <div class="ibox" v-show="$user.isCarrier">
      <div class="ibox-content">

        <form class="form-material" data-vv-scope="payment">

          <h2>Payment Details</h2>

          <div class="margin-20"></div>

          <div class="form-group-outer">
            <div class="form-group float-label-control form-group" :class="{ 'has-error': errors.has('payment.accountName') }">
              <label for="">Account Name</label>
              <input type="text" v-model="accountName" v-validate="'required'" name="accountName" class="form-control" placeholder="Account Name" v-float-label />
            </div>
          </div><!-- /.form-group-outer -->

          <div class="row">
            <div class="col-sm-4">
              <div class="form-group-outer">
                <div class="form-group float-label-control form-group" :class="{ 'has-error': errors.has('payment.bsb') }">
                  <label for="">BSB</label>
                  <input type="text" v-model="bsb" v-validate="'required'" name="bsb" class="form-control" placeholder="BSB" v-float-label />
                </div>
              </div><!-- /.form-group-outer -->
            </div>
            <div class="col-sm-8">
              <div class="form-group-outer">
                <div class="form-group float-label-control form-group" :class="{ 'has-error': errors.has('payment.accountNumber') }">
                  <label for="">Account Number</label>
                  <input type="text" v-model="accountNumber" v-validate="'required'" name="accountNumber" class="form-control" placeholder="Account Number" v-float-label/>
                </div>
              </div><!-- /.form-group-outer -->
            </div>
          </div><!-- /.row -->

          <div class="text-right">
            <ladda-button type="success" :on-click="handleSavePaymentDetails">Save Details</ladda-button>
          </div>

        </form><!-- /.form-material -->

      </div>
    </div><!-- /.ibox -->

    <div class="ibox" v-show="editingOwnDetails">
      <div class="ibox-content">

        <form class="form-material" data-vv-scope="password">
          <h2>Password Change</h2>

          <div class="margin-20"></div>

          <div class="row row-clear-md-6">
            <div class="col-md-6">
              <div class="form-group-outer">
                <div class="form-group float-label-control" :class="{ 'has-error': errors.has('password.password_current') }">
                  <label for="">Current Password</label>

                  <input
                    type="password"
                    class="form-control"
                    placeholder="Current Password"
                    name="password_current"
                    v-validate="'required'"
                    v-model="password.current"
                    v-float-label>
                </div>
              </div>
            </div>
          </div>

          <div class="row row-clear-md-6">
            <div class="col-md-6">
              <div class="form-group-outer">
                <div class="form-group float-label-control" :class="{ 'has-error': errors.has('password.password_new') }">
                  <label for="">New Password</label>

                  <input
                    type="password"
                    class="form-control"
                    placeholder="New Password"
                    name="password_new"
                    v-validate="'required|confirmed:password_new_confirmation'"
                    v-model="password.new"
                    v-float-label>
                </div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group-outer">
                <div class="form-group float-label-control" :class="{ 'has-error': errors.has('password.password_new_confirmation') }">
                  <label for="">Repeat New Password</label>

                  <input
                    type="password"
                    class="form-control"
                    placeholder="Repeat New Password"
                    name="password_new_confirmation"
                    v-validate="'required'"
                    v-model="password.newConfirmation"
                    v-float-label>
                </div>
              </div>
            </div>
          </div>

          <div class="text-right">
            <ladda-button type="info" :on-click="handleChangePassword">Change Password</ladda-button>
          </div>
        </form>
      </div>
    </div>

    <div class="ibox" v-show="canChangeAccountType">
      <div class="ibox-title">
        <strong>Account Settings</strong>
      </div>
      <div class="ibox-content">
        <form data-vv-scope="admins">
          <div class="row">
            <div class="col-md-4 col-lg-4">
              <div class="form-group" :class="{ 'has-error': errors.has('admins.role') }">
                <label class="control-label">Account Type</label>

                <selectize
                  :options="accountRoleOptions"
                  :disable-delete="true"
                  name="role"
                  v-model="role"
                  v-validate="'required'">
                </selectize>
              </div>
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="form-group" :class="{ 'has-error': errors.has('admins.parent') }">
                <label class="control-label">Parent</label>
                <multiselect v-model="parent" :options="parentOptions" track-by="id" label="text" placeholder="Select Parent" :allowEmpty="false">
                </multiselect>
              </div>
            </div>
            <div class="col-md-4 col-lg-4">
              <div class="form-group" v-if="canChangeCommission" :class="{ 'has-error': errors.has('admins.commission') }">
                <label class="control-label">Commission</label>

                <div class="input-group">
                  <input
                    type="text"
                    class="form-control"
                    v-model="commission"
                    data-vv-scope="admins"
                    v-validate="'required|decimal|between:0,100'"
                    name="commission">

                  <span class="input-group-addon">%</span>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 col-md-12 text-right">
              <ladda-button type="info" size="small" class="btn-change-account-type m-t-md" :on-click="handleSaveRoleAndCommission">Save</ladda-button>
            </div>
          </div>
        </form>
      </div>
    </div>

    <div class="modal fade modal-insurance-documents" tabindex="-1" role="dialog">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            Insurance Documents
          </div><!-- /.modal-header -->
          <div class="modal-body">

            <p class="m-t-md strong">Please upload the following current documents:</p>
            <ol>
              <li>Comprehensive Insurance (include the schedule of trucks)</li>
              <li>Public Liability ($10,000,000 or more)</li>
              <li>Marine Transit ($100,000 or more)</li>
              <li>Prime Mover Registration Certificates</li>
              <li>Workers Compensation Certificate (if applicable)</li>
            </ol>

          </div><!-- /.modal-body -->
          <div class="modal-footer">
            <button type="button" class="btn btn-sm btn-default" data-dismiss="modal">Close</button>
          </div><!-- /.modal-footer -->
        </div><!-- /.modal-content -->
      </div>
    </div><!-- /.modal -->

  </div>
</template>

<script>
  import { has, each, cloneDeep, get } from 'lodash'
  import { mapActions, mapMutations } from 'vuex'
  import { SET_USER_ATTRIBUTE, SET_AUTHORIZED, SET_USER } from 'vx/mutations'
  import { Selectize, LaddaButton, DateRange, PhotoCropper } from 'components/forms'
  import { Roles } from 'utils/user'
  import { stateMapper, existingUser } from 'mixins/user'
  import { notify, alert, url } from 'utils'
  import AccountCredit from './AccountCredit'
  import states from 'mixins/states'
  import $ from 'jquery'
  import Multiselect from 'vue-multiselect'

  export default {
    mixins: [states, stateMapper, existingUser],

    data () {
      return {
        stateProperty: 'user',
        mutationProperty: SET_USER_ATTRIBUTE,
        performingUserArchive: false,
        performingUserEnabling: false,
        performingUserDisabling: false,
        performingUserManualVerification: false,
        performingUserVerificationMail: false,
        performingCarrierActivation: false,
        password: {
          current: null,
          new: null,
          newConfirmation: null
        },
        insuranceDocument: {
          id: null,
          title: null,
          expiry: null,
          file: null,
          file_name: null
        },
        is_driver: false,
        photo: null,
        originalPhotoDataUri: null,
        parentOptions: []
      }
    },

    components: {
      Selectize,
      LaddaButton,
      AccountCredit,
      DateRange,
      PhotoCropper,
      Multiselect
    },

    created () {
      const fetchOriginalPhotoDataUri = () => {
        if (this.user.driver_id) {
          return this.getDriverPhotoDataUri({ id: this.user.driver_id, dimension: 'original' }).then(response => {
            this.originalPhotoDataUri = response.data.data_uri
          }).catch(error => {
            if (get(error, 'response.statusCode') === 404) {
              // console.error(`Driver ${this.accountUser.driver_id} has been deleted`)
              this.originalPhotoDataUri = null
            }
          })
        }

        return Promise.resolve()
      }

      this.attemptToLoadExistingUser().then(response => {
        if (this.user.driver_id !== null) {
          this.is_driver = true
        }

        this.$watch('is_driver', () => {
          this[this.mutationProperty]({ attribute: 'driver_profile', value: { licence: null, licence_expiry: null, photo_name: null, photo_storage_path: null } })
        })
      }).then(fetchOriginalPhotoDataUri).catch(this.redirectToAccountSettings)

      this.loadParentOptions()
    },

    computed: {
      canUploadInsuranceDocument () {
        // a carrier can view his own files
        // and admin or coordinator can view carrier's files
        return this.$user.isCarrier ||
          (this.$user.isAdminOrCoordinator && this.user.role && this.user.role.name === 'carrier')
      },

      noUserDocuments () {
        return !(this.user.documents && this.user.documents.length > 0)
      },

      /**
       * Determine if user is a master client or carrier account.
       *
       * @return boolean
       */
      userIsMasterClientOrCarrier () {
        return this.user.isClientOrCarrier && this.user.isMaster
      },

      /**
       * Determine if user is a carrier
       */
      userIsCarrier () {
        return this.user.isCarrier
      },

      /**
       * Get the account role options based on user type (child or master).
       *
       * @return array
       */
      accountRoleOptions () {
        let options = [
          { id: Roles.CLIENT, text: 'Client' },
          { id: Roles.CARRIER, text: 'Carrier' },
          { id: Roles.COORDINATOR, text: 'Co-Ordinator' }
        ]

        if (this.user.isChild) {
          options.unshift({ id: Roles.CHILD, text: 'Child Account' })
        }

        return options
      },

      /**
       * Determine if we can change account type details.
       *
       * @return boolean
       */
      canChangeAccountType () {
        return this.$user.isAdmin && this.user.isNotAdmin
      },

      /**
       * Determine if we can set a users commission. Only available for coordinators.
       *
       * @return boolean
       */
      canChangeCommission () {
        return this.role === Roles.COORDINATOR
      },

      /**
       * Determine if we can perform user actions against the user being edited.
       *
       * @return boolean
       */
      canPerformUserActions () {
        return this.$user.isAdminOrCoordinator && this.user.isClientOrCarrier
      },

      /**
       * Determine if we are editing our own details.
       *
       * @return boolean
       */
      editingOwnDetails () {
        return this.$user.id === this.user.id
      },

      /**
       * Get the route to the credit notes based on whether we are an admin performing
       * actions on a user or if we are a user editing our own details.
       *
       * @return object
       */
      routeToCreditNotes () {
        if (this.canPerformUserActions) {
          return { name: 'users.credit-notes', params: { id: this.user.id } }
        }

        return { name: 'account.credit-notes' }
      },

      /**
       * Determine if we are editing a document
       *
       * @return boolean
       */
      editingDocument () {
        return this.insuranceDocument.id != null
      },

      photoPath () {
        if (this.user.driver_profile) {
          return this.user.driver_profile.photo_storage_path
        }

        return null
      },

      photoName () {
        if (this.user.driver_profile) {
          return this.user.driver_profile.photo_name
        }

        return null
      },

      role: {
        get () {
          if (this.user.isChild) {
            return Roles.CHILD
          } else {
            return this.roleId
          }
        },
        set (value) {
          this.roleId = value
        }
      },

      parent: {
        get () {
          return this.parentOptions.find(parent => {
            return parent.id === this.parentId
          })
        },
        set (value) {
          this.parentId = value.id
        }
      }
    },

    watch: {
      /**
       * When the route changes trigger an attempt to load an existing
       * user. This is because this component is used for account
       * settings and editing users.
       */
      '$route' () {
        this.attemptToLoadExistingUser().catch(this.redirectToAccountSettings)
      }
    },

    methods: {
      ...mapActions('user', [
        'updateUser',
        'updateUserPassword',
        'archiveUser',
        'enableUser',
        'disableUser',
        'verifyUser',
        'activateCarrier',
        'sendVerificationMail',
        'storeInsuranceDocument',
        'updateInsuranceDocument',
        'deleteInsuranceDocument',
        'downloadInsuranceDocument',
        'updateDriverDetails',
        'getParentOptions'
      ]),
      ...mapActions('driver', ['getDriverPhotoDataUri', 'uploadDriverPhoto']),
      ...mapMutations('user', [SET_AUTHORIZED, SET_USER]),

      /**
       * Get a document download URL.
       *
       * @param object document
       *
       * @return string
       */
      getDocumentDownloadUrl (document) {
        return url(`users/${this.user.id}/documents/${document.id}/download`)
      },

      /**
       * Redirect to the account settings page.
       *
       * @return void
       */
      redirectToAccountSettings () {
        this.$router.push({ name: 'account.settings' })
      },

      /**
       * Update a user state after a saving action.
       *
       * @param object response
       *
       * @return Promise
       */
      updateUserState (response) {
        this[SET_USER](response.data)

        return response
      },

      /**
       * Handle saving a carrier's payment details
       */
      handleSavePaymentDetails () {
        const notifyErrors = () => {
          notify.error('Payment fields required.')
        }

        let payload = {
          account_number: this.accountNumber,
          bsb: this.bsb,
          account_name: this.accountName
        }

        return this.validateScope('payment').then(() => {
          return this.updateUser({ id: this.user.id, payload }).then(this.updateUserState)
        }).catch(notifyErrors)
      },

      /**
       * Handle saving user details.
       *
       * @return Promise
       */
      handleSaveAccountDetails () {
        return this.validateScope('account').then(() => {
          const updateAuthorizedUserIfRequired = (response) => {
            if (this.user.id === this.$user.id) {
              this[SET_AUTHORIZED](response.data)
            }
          }

          const mapServerErrorsToLocal = (error) => {
            if (error.response && error.response.status === 422) {
              each(error.response.data.errors, (errors, key) => {
                each(errors, error => {
                  this.errors.add(key, error, null, 'account')
                  notify.error(error)
                })
              })
            } else {
              notify.error('There was a problem saving your account details.')
            }
          }

          let payload = {
            name: this.name,
            surname: this.surname,
            mobile: this.mobile,
            email: this.email,
            company_name: this.companyName,
            company_phone: this.companyPhone,
            company_abn: this.companyAbn,
            address_line_1: this.addressLineOne,
            address_line_2: this.addressLineTwo,
            state: this.state,
            suburb: this.suburb,
            postcode: this.postcode,
            notify_public_jobs: this.notifyPublicJobs
          }

          return this.updateUser({ id: this.user.id, payload })
                     .then(this.updateUserState)
                     .then(updateAuthorizedUserIfRequired)
                     .catch(mapServerErrorsToLocal)
        })
      },

      /**
       * Handle changing of a users password.
       *
       * @return Promise
       */
      handleChangePassword () {
        return this.validateScope('password').then(() => {
          const notifyUpdated = () => (notify.success('Password has been changed.'))
          const notifyFailed = () => (notify.error('Password was not changed. Please check your current password and try again.'))

          let payload = {
            password_current: this.password.current,
            password_new: this.password.new,
            password_new_confirmation: this.password.newConfirmation
          }

          return this.updateUserPassword({ id: this.user.id, payload }).then(notifyUpdated).catch(notifyFailed)
        })
      },

      /**
       * Handle archiving a user.
       *
       * @return void
       */
      handleArchive () {
        if (this.performingUserArchive) {
          return
        }

        this.performingUserArchive = true

        const finishedPerformingArchiving = () => (this.performingUserArchive = false)
        const notifyArchived = () => (notify.success('User has been archived.'))

        this.archiveUser(this.user.id).then(this.updateUserState).then(finishedPerformingArchiving).then(notifyArchived)
      },

      /**
       * Handle enabling a user.
       *
       * @return void
       */
      handleEnable () {
        if (this.performingUserEnabling) return

        this.performingUserEnabling = true

        const finishedPerformingEnabling = () => {
          this.performingUserEnabling = false

          notify.success('User has been enabled.')
        }

        const failedPerformingEnabling = () => {
          this.performingUserEnabling = false

          notify.error('Unable to enable the user.')
        }

        this.enableUser(this.user.id).then(this.updateUserState).then(finishedPerformingEnabling).catch(failedPerformingEnabling)
      },

      /**
       * Handle disabling a user.
       *
       * @return void
       */
      handleDisable () {
        if (this.performingUserDisabling) return

        this.performingUserDisabling = true

        const finishedPerformingDisabling = () => {
          this.performingUserDisabling = false

          notify.success('User has been disabled.')
        }

        const failedPerformingDisabling = () => {
          this.performingUserDisabling = false

          notify.error('Unable to disable the user.')
        }

        this.disableUser(this.user.id).then(this.updateUserState).then(finishedPerformingDisabling).catch(failedPerformingDisabling)
      },

      /**
       * Handle manual user verification.
       *
       * @return void
       */
      handleManualVerification () {
        if (this.performingUserManualVerification) return

        this.performingUserManualVerification = true

        const finishedPerformingVerification = () => {
          this.performingUserManualVerification = false

          notify.success('User has been verified.')

          this.$bus.$emit('updateNavigation')
        }

        const failedPerformingVerification = () => {
          this.performingUserManualVerification = false

          notify.error('Unable to verify the user.')
        }

        this.verifyUser(this.user.id).then(this.updateUserState).then(finishedPerformingVerification).catch(failedPerformingVerification)
      },

      /**
       * Handle sending a verification email.
       *
       * @return void
       */
      handleVerificationMail () {
        if (this.performingUserVerificationMail) return

        this.performingUserVerificationMail = true

        const finishedPerformingVerificationMail = () => {
          this.performingUserVerificationMail = false

          notify.success('User verification email has been sent.')
        }

        const failedPerformingVerificationMail = () => {
          this.performingUserVerificationMail = false

          notify.error('Unable to send the verification email.')
        }

        this.sendVerificationMail(this.user.email).then(finishedPerformingVerificationMail).catch(failedPerformingVerificationMail)
      },

      /**
       * Handle carrier user activation.
       *
       * @return void
       */
      handleCarrierActiviation () {
        if (this.performingCarrierActivation) return

        this.performingCarrierActivation = true

        const finishedPerformingActivation = () => {
          this.performingCarrierActivation = false

          notify.success('User has been activated.')

          this.$bus.$emit('updateNavigation')
        }

        const failedPerformingActivation = () => {
          this.performingCarrierActivation = false

          notify.error('Unable to activate the user.')
        }

        this.activateCarrier(this.user.id).then(this.updateUserState).then(finishedPerformingActivation).catch(failedPerformingActivation)
      },

      /**
       * Handle saving role and commission of a user.
       *
       * @return Promise
       */
      handleSaveRoleAndCommission () {
        const alertIfUserRoleChangedFromClient = () => {
          if (this.user.isChild && this.role !== Roles.CHILD) {
            return alert.confirm({ text: 'This user will no longer be a child account. You are unable to undo this action.' })
          }

          return Promise.resolve()
        }

        return this.validateScope('admins').then(alertIfUserRoleChangedFromClient).then(() => {
          let payload = {}

          if (this.role !== Roles.CHILD) {
            payload.role_id = this.role
          }

          payload.parent_id = this.parentId === 0 ? null : this.parentId

          if (this.canChangeCommission) {
            payload.commission_amount = this.commission
          }

          const notifyUpdated = () => (notify.success('Account details have been saved.'))
          const notifyFailed = (error) => {
            if (error.response && error.response.status === 422) {
              if (has(error.response.data.errors, 'role')) {
                notify.error(error.response.data.errors.role.shift())
              } else {
                notify.error('There was a problem updating the users role.')
              }
            }
          }

          return this.updateUser({ id: this.user.id, payload }).then(this.updateUserState).then(notifyUpdated).catch(notifyFailed)
        })
      },

      /**
       * Handle changes to the selected file.
       *
       * @param object files
       *
       * @return void
       */
      handleFileSelection ({ target: { files = [] } }) {
        if (files.length === 0) {
          this.insuranceDocument.file = null

          return
        }

        this.insuranceDocument.file = files.item(0)
        this.insuranceDocument.file_name = files.item(0).name
      },

      /**
       * Set a blank document and open collapse div
       */
      handleAddDocument () {
        this.insuranceDocument = {
          id: null,
          title: null,
          expiry: null,
          file: null,
          file_name: null
        }

        $('.document-details-collapse').collapse('show')
      },

      /**
       * If editing an existing document then we update that one
       * otherwise we save the new document
       */
      handleSaveDocument (doc) {
        const notifyErrors = () => {
          notify.error('A file must be selected')
        }

        const resetDocument = () => {
          this.insuranceDocument = {
            id: null,
            title: null,
            expiry: null,
            file: null,
            file_name: null
          }

          return $('.document-details-collapse').collapse('hide')
        }

        return this.validateScope('document').then(() => {
          if (this.editingDocument) {
            return this.updateInsuranceDocument({ userId: this.user.id, documentId: this.insuranceDocument.id, insurance: this.insuranceDocument }).then(resetDocument)
          } else {
            return this.storeInsuranceDocument({ id: this.user.id, insurance: this.insuranceDocument }).then(resetDocument)
          }
        }).catch(notifyErrors)
      },

      /**
       * Open the collapse div and prefill the fields with the clicked documents data
       */
      handleEditDocument (doc) {
        this.insuranceDocument = cloneDeep(doc)
        this.insuranceDocument.file = null
        $('.document-details-collapse').collapse('show')
      },

      /**
       * Delete a document
       */
      handleDeleteDocument (doc) {
        return alert.delete({ text: 'Are you sure you want to delete this document?' }).then(() => {
          return this.deleteInsuranceDocument({ userId: this.user.id, documentId: doc.id })
        })
      },

      /**
       * Handle saving the user's driver details
       */
      handleSaveDriverDetails () {
        let payload = {
          is_driver: this.is_driver,
          licence: this.licence,
          licence_expiry: this.licenceExpiry
        }

        return this.updateDriverDetails({ userId: this.user.id, payload }).then(this.handlePhotoUpload)
      },

      /**
       * Handle uploading driver photo.
       *
       * @param object response
       *
       * @return Promise
       */
      handlePhotoUpload (response) {
        if (this.photo && response.data.driver_id) {
          return this.uploadDriverPhoto({ id: response.data.driver_id, file: this.photo.file, crop: this.photo.crop })
        }

        return Promise.resolve(response)
      },

      loadParentOptions () {
        this.getParentOptions().then(response => {
          let options = response.data.data
          options.unshift({
            id: 0,
            text: 'None'
          })
          this.parentOptions = options
        })
      }
    }
  }
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// Form.vue?be71108a